export class PropertyChange {
    property: string;
    object: any;
    source: any;

    constructor (property: string, object: any, source: any) {
        this.property = property;
        this.object = object;
        this.source = source;
    }
}
